<div class="flex items-center text-[15px] leading-[1] gap-1">
  @if (+htmlTimer.days > 0) {
    <div class="h-[35px] min-w-[48px] flex items-center justify-center text-white border-solid border border-white rounded-[5px]">{{htmlTimer.days}}d</div>
    <span class="text-[20px] leading-[1] text-white">:</span>
  }
  <div class="h-[35px] min-w-[48px] flex items-center justify-center text-white border-solid border border-white rounded-[5px]">{{htmlTimer.hours}}h</div>
  <span class="text-[20px] leading-[1] text-white">:</span>
  <div class="h-[35px] min-w-[54px] flex items-center justify-center text-white border-solid border border-white rounded-[5px]">{{htmlTimer.minutes}}m</div>
  <span class="text-[20px] leading-[1] text-white">:</span>
  <div class="h-[35px] min-w-[45px] flex items-center justify-center text-white border-solid border border-white rounded-[5px]">{{htmlTimer.seconds}}s</div>
</div>
